import { defineComponent as _defineComponent } from 'vue'
import { Area } from '@ilteducation/content-ref-data-types';
import { ref } from 'vue';
import VideoList from '@/components/areas/VideoList.vue';
import { useOrderedVideos } from '@/comp/use-ordered-videos';


export default /*#__PURE__*/_defineComponent({
  __name: 'Edit',
  props: {
    id: null,
    title: null,
    item: null
  },
  setup(__props: any) {

const props = __props as { id: string; title: string; item: Area }


const videos = ref<VideoV1[]>([]);
useOrderedVideos()
  .fetchVideos(props.item.id)
  .then((areaVideos) => {
    videos.value = areaVideos;
  });

return { __sfc: true,props, videos, VideoList }
}

})